import React, { useState} from "react";
import {Button, Flex} from '@chakra-ui/react'
import {useAuth} from '../..'
import { InputField, Form, Alert} from "../../../components";
import * as yup from 'yup'

const LoginForm = ({onSuccess}) => {
    const { login } = useAuth()
    const [serverSideError, setServersideError] = useState(false)

    const LoginValidation = yup.object().shape({
        username:yup 
        .string()
        .required('Te rugăm să introduci un utilizator')
        .matches(/^[\S]+$/, 'Te rugăm să elimini spațiile.'),
        password: yup.string().required('Te rugăm să introduci o parolă')
    })

    return(
        <Flex flexDirection="column">
            <Alert
                show={!!serverSideError}
                description={serverSideError}
                status="warning"
                dismissible
                onClose={() => setServersideError(false)}
                mb="6"
                />
            <Form 
            initialValues = {{ username: '', password: ''}}
            onSubmit={async (values, actions)=> {
                try{
                    await login(values)
                    onSuccess()
                } catch (error) {
                    const errorResponse = error.response.data
                    const fieldErrors = errorResponse.metaData.reduce(
                        (acc, metadataError) => {
                            return {...acc, [metadataError.field]: metadataError.error}
                        },
                        {}
                    )
                    actions.setErrors(fieldErrors)
                    setServersideError(errorResponse.message)
                    actions.setSubmitting(false)
                }
            }}
            validationSchema={LoginValidation}
            >
                {(formikProps) => (
                    <Flex flexDirection="column" css = {{gap: '1.5rem'}} align="center">
                        <InputField 
                            name="username"
                            label="Utilizator"
                            placeholder="Utilizator"
                            hideCheckIcon
                            />
                        <InputField
                        name="password"
                        type="password"
                        label="Parolă"
                        placeholder="Parolă"
                        hideCheckIcon
                        autoComplete="current-password"
                        />
                        <Button
                        type="submit"
                        isLoading={formikProps.isSubmitting}
                        isDisabled={!formikProps.isValid || !formikProps.dirty}
                        >
                            Intră în cont
                        </Button>
                    </Flex>
                )}
            </Form>
        </Flex>
    )
}

export default LoginForm